var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"RowingVideoPlayer",staticClass:"video-js vjs-16-9 vjs-big-play-centered transcoded-video-player",attrs:{"type":"video","width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }